import { Skeleton } from './Skeleton';

interface Props {
  /** KPI / карт тоо (эхний мөр). */
  cards?: number;
  /** Хүснэгтийн мөрийн тоо. */
  rows?: number;
}

/** Lazy route ачаалж байх үед хуудасны хэлбэрийг урьдчилан харуулах skeleton
 *  (spinner-ийн оронд — агуулга «үсрэхгүй»). */
export function PageSkeleton({ cards = 4, rows = 6 }: Props) {
  return (
    <div className="ts-page-skel fade-in" aria-busy="true" aria-label="Уншиж байна">
      <div className="ts-page-skel-head">
        <Skeleton height={22} width={220} borderRadius={8} />
        <Skeleton height={13} width={340} />
      </div>
      {cards > 0 ? (
        <div className="ts-page-skel-grid">
          {Array.from({ length: cards }).map((_, i) => (
            <div key={i} className="ts-page-skel-card">
              <Skeleton height={12} width="55%" />
              <Skeleton height={26} width="70%" borderRadius={8} />
              <Skeleton height={11} width="40%" />
            </div>
          ))}
        </div>
      ) : null}
      <div className="ts-page-skel-card" style={{ gap: 12 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <Skeleton height={32} width={100} borderRadius={8} />
          <Skeleton height={32} width={90} borderRadius={8} />
          <Skeleton height={32} width={90} borderRadius={8} />
          <span style={{ flex: 1 }} />
          <Skeleton height={32} width={220} borderRadius={8} />
        </div>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} height={16} width={`${92 - (i % 3) * 6}%`} />
        ))}
      </div>
    </div>
  );
}
